import {
  SUB_AVAILABLE_MODULE_ALL,
  SUB_AVAILABLE_MODULE_ERROR,
  SUB_AVAILABLE_MODULE_LOADING,
  SUB_AVAILABLE_MODULE_PUT,
} from '../types';

import api from '../../../utils/functions/api';

export const subAvailableModuleAll = () => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/sub-available-module`,
    );
    if (status === 200) {
      dispatch({ type: SUB_AVAILABLE_MODULE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: SUB_AVAILABLE_MODULE_ERROR });
    throw new Error(error);
  }
};

export const subAvailableModulePut = (id, payload) => async (dispatch) => {
  try {
    console.log('COME IN');
    dispatch({ type: SUB_AVAILABLE_MODULE_LOADING });
    console.log('after loading');
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/sub-available-module/${id}`,
      payload,
    );
    dispatch({ type: SUB_AVAILABLE_MODULE_PUT, payload: data });
  } catch (error) {
    console.error('error', error);
    dispatch({ type: SUB_AVAILABLE_MODULE_ERROR });
    throw new Error(error);
  }
};
